module.exports = __webpack_public_path__ + "static/media/range_3_gray.9cc487aa.png";